import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import { getImageLocal } from '@/utils/locals';
import EFAppArrow from '@/components/UI/svg/Icons/EFAppArrow';
import { createEFPic } from '@/utils/useEFPic';
import AppPointDeltaAdv from '@/components/AppPoint/DeltaAdvPC';
import { SHOW_APP_POINT_SITES } from '@/constants';

const { EFPic } = createEFPic('/media/deltapro/pc/');

export default function Section16() {
    const { useLang, useRouter, Link } = useGlobal();
    const { locale } = useRouter();
    const appImgLocal = getImageLocal(locale, ['jp', 'de', 'fr', 'cn']);
    const { t } = useLang('delta_pro_new');
    const appRedirct = ['us', 'ca', 'uk', 'au', 'de', 'fr', 'jp', 'za', 'mx'];

    return (
        <div
            className={`${css.section16} GtmModuleData-section`}
            data-section-id={css.section16}
            data-section-title={t.rich('control_consumption_pc', {
                lin1: (child: string) => child,
                line2: (child: string) => child,
            })}
        >
            <div className="head">
                {locale === 'jp'
                    ? t.rich('control_consumption_pc', {
                          line2: (child: string) => <h4 className="subTitle font-family-bold">{child}</h4>,
                          line1: (child: string) => <h2 className="title font-family-extrabold">{child}</h2>,
                      })
                    : t.rich('control_consumption_pc', {
                          line1: (child: string) => <h2 className="title font-family-extrabold">{child}</h2>,
                          line2: (child: string) => <h4 className="subTitle font-family-bold">{child}</h4>,
                      })}
            </div>
            <div className="center">
                <div className="item left">
                    <div className="content">
                        <div className="bg bgImg1">
                            <EFPic name={['section_16_1.webp', 'section_16_1.png']} alt="" />
                        </div>
                        <div className="text">
                            <h2 className="textTitle font-family-semibolder">{t('wired_control')}</h2>
                            <p className="textContent font-family-semibolder">{t('wired_control_desc')}</p>
                        </div>
                    </div>
                </div>
                <div className="item right">
                    <div className="bg bgImg1">
                        <EFPic name={[`section_16_2_${appImgLocal}.webp`, `section_16_2_${appImgLocal}.png`]} alt={''} />
                    </div>

                    <div className="text">
                        <h2 className="textTitle font-family-semibolder">{t('wiredless_control')}</h2>
                        <p className="textContent font-family-semibolder">{t('wiredless_control_desc')}</p>
                        {appRedirct.includes(locale) && (
                            <Link
                                href="/app"
                                className="link_learn GtmModuleData-btn-href"
                                newWin
                                dataLayer={{
                                    __btn_id1: css.section16,
                                    __btn_id2: '/app',
                                }}
                            >
                                <div className="text2">{t('learn_more')}</div>
                                <div className="icon">
                                    <EFAppArrow />
                                </div>
                            </Link>
                        )}
                    </div>
                </div>
            </div>
            {SHOW_APP_POINT_SITES.includes(locale) && <AppPointDeltaAdv style={{ background: 'unset' }} />}
            <div className="bottom">
                <div className="bg bgImg2">
                    <EFPic name={['section_16_3.webp', 'section_16_3.png']} alt="" />
                </div>
                <div className="text">
                    <h2 className="textTitle font-family-semibolder">{t('unit_control')}</h2>
                    <p className="textContent font-family-semibolder">{t('unit_control_desc')}</p>
                </div>
            </div>
        </div>
    );
}
